import { Box, Stack, Text } from '@mantine/core'
import ReactMarkdown from 'react-markdown'

import type { HelpEntry } from '@/configs/helpContent.types'
import { useGlobalState } from '@/hooks/useGlobalState'

type HelpEntryAnswerProps = {
  entry: HelpEntry
}

export function HelpEntryAnswer({ entry }: HelpEntryAnswerProps) {
  const { authenticationStore } = useGlobalState()
  const { isSponsorAdmin } = authenticationStore

  // Determine the user's role
  const userRole = isSponsorAdmin ? 'Program Manager' : 'Expert'

  // Get the appropriate answer based on role, falling back to the default answer
  const answer = entry.roleBasedAnswers?.[userRole] || entry.answer

  return (
    <Stack px="xl">
      <ReactMarkdown
        components={{
          p: ({ children }) => <Text mb="xs">{children}</Text>,
          ol: ({ children }) => (
            <Box component="ol" mt={0} mb="xs">
              {children}
            </Box>
          ),
          ul: ({ children }) => (
            <Box component="ul" mt={0} mb="xs">
              {children}
            </Box>
          ),
        }}>
        {answer}
      </ReactMarkdown>
    </Stack>
  )
}
